import { RegistrationStepsNav } from 'app/components/shared/RegistrationStepsNav'
import { Base } from 'app/components/ui/Base'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useLayout } from 'app/contexts/LayoutProvider'
import { RegistrationFormSteps } from 'EstraSponsor'
import React, { useLayoutEffect, useState } from 'react'
import styled from 'styled-components'

import { UserRegistrationForm } from './UserRegistrationForm'

export const UserRegistration = (): JSX.Element => {
  const { updateLayoutData } = useLayout()

  const [activeStep, setActiveStep] =
    useState<RegistrationFormSteps>('user_data')

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle:
        activeStep === 'user_data'
          ? 'Registra i dati anagrafici della tua attività e procedi con l’attivazione'
          : 'Manca poco, devi solo indicare i tuoi dati contabili',
      headerVariant: 'authentication',
    })
  }, [activeStep, updateLayoutData])

  return (
    <Base>
      <Container>
        <RegistrationStepsNavWrapper>
          <RegistrationStepsNav currentStep={activeStep}></RegistrationStepsNav>
        </RegistrationStepsNavWrapper>
        {activeStep === 'user_data' && (
          <HeaderWrapper>
            <Text variant='s24' mb={2}>
              ... è arrivato il momento di compilare l’anagrafica della tua
              attività.{'\n'}
              Lo sappiamo, il modulo è molto lungo e articolato e potrebbe
              richiedere dati che non hai immediatamente disponibili. Tuttavia,
              è necessario compilarlo tutto, per cui abbiamo attivato una
              funzione di “bozza” che, utilizzando il pulsante “SALVA I DATI” in
              fondo alla pagina, ti consentirà di riprendere la compilazione in
              più momenti, a tuo comodo.{'\n'}
              <b>
                Devi completare tutti gli step per inviarci richieste di
                sponsorizzazione.
              </b>
              {'\n\n'}
              {/* <>
                Se non vuoi procedere adesso alla compilazione, puoi chiudere
                questa pagina usando il pulsante qui sotto e ritornare più tardi,
                accedendo dal sito www.estra.it/sponsor
              </> */}
            </Text>
            {/* <Button onClick={() => console.log('TODO')}>
            CHIUDI LA PAGINA E MANDA UN PROMEMORIA
          </Button> */}
            {/* {sendReminderEmailError ? (
            <ApiErrorMessage>{sendReminderEmailError}</ApiErrorMessage>
          ) : null}*/}
          </HeaderWrapper>
        )}
      </Container>
      <UserRegistrationForm
        activeStep={activeStep}
        setActiveStep={setActiveStep}
      ></UserRegistrationForm>
    </Base>
  )
}

const RegistrationStepsNavWrapper = styled.div`
  margin-bottom: 3rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    margin-bottom: 6rem;
  }
`

const HeaderWrapper = styled.div`
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 3rem;
`
